import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BroadcastOnHomeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"broadcast_on_home"}/>
}
